// --------------- TYPES ---------------
import { GetUsers, GetUser, UpdateUser, DeleteUser } from '../Types'

// --------------- INITIAL STATE ---------------
const INITIAL_STATE = { error: null }

// --------------- REDUCER FUNCTION ---------------
// eslint-disable-next-line import/no-anonymous-default-export
export default (state = INITIAL_STATE, action) => {
  switch (action.type) {
    case GetUsers.REQUEST:
      return {
        ...state,
        isGetUsersSuccess: null,
        error: null,
      }
    case GetUsers.SUCCESS:
      return {
        ...state,
        isGetUsersSuccess: true,
        getUsersData: action.payload,
      }
    case GetUsers.FAILED:
      return {
        ...state,
        isGetUsersSuccess: false,
        error: action.payload,
      }
    case GetUser.REQUEST:
      return {
        ...state,
        isGetUserSuccess: null,
        error: null,
      }
    case GetUser.SUCCESS:
      return {
        ...state,
        isGetUserSuccess: true,
        getUserData: action.payload,
      }
    case GetUser.FAILED:
      return {
        ...state,
        isGetUserSuccess: false,
        error: action.payload,
      }
    case UpdateUser.REQUEST:
      return { ...state, isUpdateUserSuccess: null, error: null }
    case UpdateUser.SUCCESS:
      return { ...state, isUpdateUserSuccess: true, updatedUser: action.payload }
    case UpdateUser.FAILED:
      return { ...state, isUpdateUserSuccess: false, error: action.payload }
    case DeleteUser.REQUEST:
      return { ...state, isDeleteUserSuccess: null, error: null }
    case DeleteUser.SUCCESS:
      return { ...state, isDeleteUserSuccess: true, deletedUser: action.payload }
    case DeleteUser.FAILED:
      return { ...state, isDeleteUserSuccess: false, error: action.payload }
    default:
      return state
  }
}
